import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.manager-marquee__splide' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          gap: '2rem',
          perPage: 5,
          pagination: false,
          arrows: false,
          autoScroll: {
            speed: 1,
          },
          breakpoints: {
            1024: {
              perPage: 3,
            },
            768: {
              perPage: 1,
            },
          },
        } );
        slider.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'manager-marquee', COMPONENT );
} )( app );
